import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import InputTextField from "../InputText/InputText";
import { baseurl } from "../BaseUrl/Baseurl";
import axios from "axios";
import { useSelector } from "react-redux";
import { IoCloseSharp } from "react-icons/io5";
import MultiSelectDropdown from "../AdminConsole/MultiSelect";
import SuccessToast from "../Toast/SuccessToast";
import ErrorToast from "../Toast/ErrorToast";

export default function RegionCreateModal({
  btnClick,
  status,
  fieldName1,
  fieldName2,
  tab,
  onSuccess,
  onError,
}) {
  const [successtoastmsg, setSuccesstoastmsg] = useState("");
  const [successtoastmsgstatus, setSuccesstoastmsgstatus] = useState(false);
  const [messageList, setMessageList] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [state, setState] = useState(() => {
    const stored = sessionStorage.getItem("areastate");
    return stored ? JSON.parse(stored) : "";
  });
  const [area, setarea] = useState(() => {
    const stored = sessionStorage.getItem("areaarea");
    return stored ? JSON.parse(stored) : "";
  });
  const [circle, setcircle] = useState(() => {
    const stored = sessionStorage.getItem("commonfield");
    return stored ? JSON.parse(stored) : "";
  });

  const [division, setdivision] = useState(() => {
    const stored = sessionStorage.getItem("multiselect");
    return stored ? JSON.parse(stored) : [];
  });

  const [options, setOptions] = useState(() => {
    const stored = sessionStorage.getItem("multiselectoptions");
    return stored ? JSON.parse(stored) : [];
  });
  // eslint-disable-next-line no-unused-vars
  const [options1, setOptions1] = useState([]);

  const [locationDescription, setLocationDescription] = useState(() => {
    const stored = sessionStorage.getItem("locationDescription");
    return stored ? JSON.parse(stored) : "";
  });

  const userData = useSelector((state) => state.userDetails);

  useEffect(() => {
    sessionStorage.setItem("areastate", JSON.stringify(state));
    sessionStorage.setItem("areaarea", JSON.stringify(area));
    sessionStorage.setItem("commonfield", JSON.stringify(circle));
    sessionStorage.setItem("multiselect", JSON.stringify(division));
    sessionStorage.setItem("multiselectoptions", JSON.stringify(options));
    sessionStorage.setItem("locationDescription", JSON.stringify(locationDescription));
  }, [state, area, circle, division, options, locationDescription]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setOptions([]);

    if (tab === "Wing") {
      axios({
        method: "GET",

        url: baseurl + "/api/get/list?field=wing&userId=" + userData.userId + "&skipAlreadyAssigned=1&isSortingRequired=2",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userData.token,
        },
      })
        .then((response) => {
          const RequestData = response.data.message;
          setOptions1(RequestData);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "GET",

        url: baseurl + "/api/get/list?field=circle&userId=" + userData.userId + "&skipAlreadyAssigned=1&isSortingRequired=2",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userData.token,
        },
      })
        .then((response) => {
          const RequestData = response.data.message;
          setOptions(RequestData);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    if (tab === "Circle") {
      axios({
        method: "GET",

        url: baseurl + "/api/get/list?field=division&userId=" + userData.userId + "&skipAlreadyAssigned=1&isSortingRequired=2",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userData.token,
        },
      })
        .then((response) => {
          const RequestData = response.data.message;
          setOptions(RequestData);
        })
        .catch((error) => {
          console.error(error);
        });

      axios({
        method: "GET",

        url: baseurl + "/api/get/list?field=circle&userId=" + userData.userId +"&isSortingRequired=2",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userData.token,
        },
      })
        .then((response) => {
          const RequestData = response.data.message;
          setOptions1(RequestData);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    if (tab === "Division") {
      axios({
        method: "GET",

        url: baseurl + "/api/get/list?field=division&userId=" + userData.userId+"&isSortingRequired=2",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userData.token,
        },
      })
        .then((response) => {
          const RequestData = response.data.message;
          setOptions1(RequestData);
        })
        .catch((error) => {
          console.error(error);
        });

      axios({
        method: "GET",

        url:
          baseurl + "/api/get/list?field=subDivision&userId=" + userData.userId + "&skipAlreadyAssigned=1&isSortingRequired=2",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userData.token,
        },
      })
        .then((response) => {
          const RequestData = response.data.message;
          setOptions(RequestData);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  const handleStateChange = (e) => {
    setState(e.target.value);
  };

  useEffect(() => {
    axios({
      method: "GET",

      url: baseurl + "/api/get/list?field=state" + "&userId=" + userData.userId+"&isSortingRequired=2",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userData.token,
      },
    })
      .then((response) => {
        const RequestData = response.data.message;
        setStateOptions(RequestData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function handlecircle(e) {
    const val = e.target.value;
    setcircle(val.length > 100 ? val.slice(0, 100) : val);
  }
  function handlearea(e) {
    const val = e.target.value;
    setarea(val.length > 100 ? val.slice(0, 100) : val);
  }
  function handleLocationDescription(e) {
    const val = e.target.value;
    setLocationDescription(val.length > 100 ? val.slice(0, 100) : val);
  }
  const validateField = (name, value) => {
    switch (name) {
      case "circle":
        return !value || String(value).trim() === ""
          ? `Please select or enter ${fieldName1}`
          : "";
      // case "division":
      //   return !value || (Array.isArray(value) && value.length === 0)
      //     ? `Please select at least one ${fieldName2}`
      //     : "";
      case "state":
        return !value || String(value).trim() === ""
          ? "Please select a State"
          : "";
      case "area":
        return !value || String(value).trim() === ""
          ? "Please enter an Area"
          : "";
      // validateField is internal and validateForm only ever passes the four
      // field names handled above, so this default is unreachable in tests.
      /* istanbul ignore next */
      default:
        return "";
    }
  };

  // Returns an array of error messages for the current tab
  const validateForm = () => {
    if (tab === "Area") {
      return [
        validateField("state", state),
        validateField("area", area),
      ].filter(Boolean);
    }
    return [
      validateField("circle", circle),
      validateField("division", division),
    ].filter(Boolean);
  };

  const ToclosesuccessToast = () => {
    setSuccesstoastmsg("");
    setSuccesstoastmsgstatus(false);
  };

  const TocloseToast1 = () => {
    setMessageList("");
    setShowToast(false);
  };

  function Create(event) {
    event.preventDefault();
    setMessageList("");
    setShowToast(false);

    // Validate before any API call
    const errors = validateForm();
    if (errors.length > 0) {
      onError(errors[0]); // first missing field, in form order
      return;
    }

    const id_list = Array.isArray(division) ? division : [division];

    if (tab === "Division") {
      const userData1 = {
        division: circle,
        subDivisionId: id_list,
        ...(locationDescription && locationDescription.trim()
          ? { locationDescription: locationDescription.trim() }
          : {}),
      };

      axios({
        method: "POST",
        url: `${baseurl}/api/list/add?userId=${userData.userId}&field=division`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.token}`,
        },
        data: userData1,
      })
        .then((response) => {
          btnClick();
          setcircle("");
          setLocationDescription("");
          sessionStorage.removeItem("locationDescription");
          onSuccess(response?.data?.message);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "Something went wrong";
          onError(errorMessage);
        });
    }

    if (tab === "Circle") {
      const userData1 = {
        circle: circle,
        divisionId: id_list,
        ...(locationDescription && locationDescription.trim()
          ? { locationDescription: locationDescription.trim() }
          : {}),
      };

      axios({
        method: "POST",
        url: `${baseurl}/api/list/add?userId=${userData.userId}&field=circle`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.token}`,
        },
        data: userData1,
      })
        .then((response) => {
          btnClick();
          setcircle("");
          setLocationDescription("");
          sessionStorage.removeItem("locationDescription");
          onSuccess(response?.data?.message);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "Something went wrong";
          onError(errorMessage);
        });
    }

    if (tab === "Wing") {
      const userData1 = {
        wing: circle,
        circleId: id_list,
        ...(locationDescription && locationDescription.trim()
          ? { locationDescription: locationDescription.trim() }
          : {}),
      };

      axios({
        method: "POST",
        url: `${baseurl}/api/list/add?userId=${userData.userId}&field=wing`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.token}`,
        },
        data: userData1,
      })
        .then((response) => {
          btnClick();
          setcircle("");
          setLocationDescription("");
          sessionStorage.removeItem("locationDescription");
          onSuccess(response?.data?.message);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "Something went wrong";
          onError(errorMessage);
        });
    }

    if (tab === "Area") {
      const userData1 = {
        area: area,
        stateId: Number.parseInt(state),
        ...(locationDescription && locationDescription.trim()
          ? { locationDescription: locationDescription.trim() }
          : {}),
      };

      axios({
        method: "POST",
        url: `${baseurl}/api/list/add?userId=${userData.userId}&field=area`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.token}`,
        },
        data: userData1,
      })
        .then((response) => {
          btnClick();
          setcircle("");
          setarea("");
          setLocationDescription("");
          sessionStorage.removeItem("locationDescription");
          onSuccess(response?.data?.message);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "Something went wrong";
          onError(errorMessage);
        });
    }
  }

  return (
    <>
      {successtoastmsgstatus && successtoastmsg !== "" && (
        <SuccessToast
          message={successtoastmsg}
          onClose={ToclosesuccessToast}
          show={successtoastmsgstatus}
        />
      )}

      {showToast && messageList !== "" && (
        <ErrorToast
          message={messageList}
          onClose={TocloseToast1}
          show={showToast}
        />
      )}

      <Modal show={status} onHide={btnClick} className="region-create-modal" size="lg" centered>
        <Modal.Body className="bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="mb-0">Create New {tab}</h6>
            <button className="btn " onClick={btnClick}>
              <IoCloseSharp />
            </button>
          </div>
          <form
            className="row d-flex justify-content-center align-center  circlediv"
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              Create(e);
            }}
          >
            <div className="col-12 col-sm-12 col-lg-6 col-xl-6 col-md-12  pb-3 pt-3">
              <label htmlFor="formFileLg" className="login-text">
                {tab === "Area" ? (fieldName1 === "state" ? "Choose State" : `Choose ${fieldName1}`) : fieldName1}
              </label>
              <center>
                {tab !== "Area" && (
                  <InputTextField
                    handleInputChange={handlecircle}
                    valueText={circle}
                    inputName="circle"
                    inputId="circle"
                    classname="project-box"
                    inputType="text"
                    maxLen={100}
                    defaultValue={circle}
                    placeholderValue={`Enter ${fieldName1}`}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                  />
                )}
                {tab === "Area" && (
                  <select
                    name="state"
                    value={state}
                    onChange={handleStateChange}
                    className="project-box "
                  >
                    <option value="">Select</option>
                    {stateOptions.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                )}
              </center>
            </div>

            {tab === "Area" && (
              <div className="col-12 col-sm-12 col-lg-6 col-xl-6 col-md-12  pb-3 pt-3">
                <label htmlFor="formFileLg" className="login-text">
                  {fieldName2 === "area" || fieldName2 === "Area" ? "Area Name" : fieldName2}
                </label>
                <center>
                  <InputTextField
                    handleInputChange={handlearea}
                    valueText={area}
                    inputName="area"
                    inputId="area"
                    classname="project-box"
                    maxLen={100}
                    inputType="text"
                    defaultValue={area}
                    placeholderValue={`Enter ${fieldName2 === "area" || fieldName2 === "Area" ? "Area Name" : fieldName2}`}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                  ></InputTextField>
                </center>
              </div>
            )}

            {tab !== "Area" && (
              <div className="col-12 col-sm-12  col-md-12 col-lg-6 col-md-12 pb-3 pt-3">
                <label htmlFor="formFileLg" className="formfontst ast form-label">
                  {fieldName2}
                </label>
                <MultiSelectDropdown
                  options={options}
                  onChangefun={setdivision}
                  value={division}
                />
              </div>
            )}

            <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pb-3 pt-2">
              <label htmlFor="locationDescription" className="login-text">
                Location Description
              </label>
              <center>
                <InputTextField
                  handleInputChange={handleLocationDescription}
                  valueText={locationDescription}
                  inputName="locationDescription"
                  inputId="locationDescription"
                  classname="project-box"
                  inputType="text"
                  maxLen={100}
                  defaultValue={locationDescription}
                  placeholderValue="Enter Location Description"
                  autoComplete="off"
                  onKeyPress={(e) => {
                    e.key === "Enter" && e.preventDefault();
                  }}
                />
              </center>
            </div>

            <div className="col-sm-12 col-lg-12 col-12 col-md-12 col-xl-12 pt-4 pb-3">
              <center>
                <button
                  onClick={Create}
                  type="submit"
                  className="search-circle"
                  name="submit"
                >
                  <b>Submit</b>
                </button>
              </center>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
